"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRequestErrorChecker = exports.IkeRequestError = exports.IkeRequestErrorType = void 0;
const core_api_1 = require("@ikegps/core-api");
var IkeRequestErrorType;
(function (IkeRequestErrorType) {
    IkeRequestErrorType["INVALID_SESSION"] = "invalid_session";
    IkeRequestErrorType["VALIDATION_FAILED"] = "validation_failed";
    IkeRequestErrorType["LICENSE_REQUIRED"] = "license_required";
    IkeRequestErrorType["UNKNOWN"] = "unknown";
})(IkeRequestErrorType || (exports.IkeRequestErrorType = IkeRequestErrorType = {}));
class IkeRequestError extends Error {
    constructor(status, obj) {
        super(`${status} ${obj.message}`);
        this.errors = [];
        this.warnings = [];
        this.info = [];
        this.status = status;
        this.statusMessage = obj.message;
        if (obj.errors) {
            this.errors = obj.errors;
        }
        if (obj.warnings) {
            this.warnings = obj.warnings;
        }
        if (obj.info) {
            this.info = obj.info;
        }
    }
    static isIkeRequestError(e) {
        return e && typeof e === 'object' && typeof e['status'] === 'number' && typeof e['statusMessage'] === 'string';
    }
}
exports.IkeRequestError = IkeRequestError;
exports.IkeRequestErrorChecker = {
    getErrorType(requestError) {
        if (requestError == null) {
            return IkeRequestErrorType.UNKNOWN;
        }
        if (requestError.status === core_api_1.IkeHTTPStatus.VALIDATION_FAILED) {
            if (requestError.errors != null && requestError.errors.some((e) => e.field === 'token')) {
                return IkeRequestErrorType.INVALID_SESSION;
            }
            if (requestError.statusMessage === 'Validation failed') {
                return IkeRequestErrorType.VALIDATION_FAILED;
            }
        }
        if (requestError.status === core_api_1.IkeHTTPStatus.FORBIDDEN) {
            if (requestError.errors !== null && requestError.errors.some((e) => e.codes === 'license_required')) {
                return IkeRequestErrorType.LICENSE_REQUIRED;
            }
        }
        return IkeRequestErrorType.UNKNOWN;
    },
    isValidationFailed(requestError) {
        const errorType = exports.IkeRequestErrorChecker.getErrorType(requestError);
        return errorType === IkeRequestErrorType.VALIDATION_FAILED;
    },
};
//# sourceMappingURL=rest.error.js.map